/**
 * Models - User Types
 */
export enum UserRole {
  ADMIN = 'admin',
  MANAGER = 'manager',
  USER = 'user'
}

export interface IUser {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  role: UserRole;
  createdAt: Date;
  lastLogin?: Date;
}

export interface IUserProfile extends IUser {
  phone?: string;
  department?: string;
  preferences?: IUserPreferences;
}

export interface IUserPreferences {
  theme?: 'light' | 'dark';
  language?: string;
  notifications?: boolean;
  emailNotifications?: boolean;
}

export type UserDTO = Omit<IUser, 'id' | 'createdAt'>;
